import {Error404, Error500} from '../components';
import {Redirect, Route, Switch} from 'react-router';

import ArticleWrapper from '../views/blog/ArticleWrapper';
import BlogWrapper from '../views/blog/BlogWrapper';
import EulaView from '../views/eula/EulaView';
import FaqView from '../views/faq/FaqView';
import HomeView from '../views/homeV2/HomeView';
import HomeViewV1 from '../views/home/HomeView';
import DownloadNowView from '../views/landing/DownloadNowView';
import React from 'react';
import SuccessView from '../views/success/SuccessView';
import {getPath} from 'epic-common/src/route';

const redirectLocale = (destination, route) => {
    const path = getPath();
    let destPath = null;
    if (typeof destination === 'function') {
        destPath = destination(route.match.params);
    } else {
        destPath = destination;
    }
    const redirectUrl = `${path}${route.match.params.locale}${destPath}${route.location.search || ''}`;
    return (
        <Redirect to={redirectUrl} />
    );
};
const goHome = redirectLocale.bind(null, '/home');
const goNews = redirectLocale.bind(null, '/news');
const goNewsCat = redirectLocale.bind(null, ({category}) => `/news/category/${category}`);
const goNewsTitle = redirectLocale.bind(null, ({title}) => `/news/${title}`);

const getRoutes = function getRoutes() {
    const path = getPath();
    const routes = (
        <Switch>
            <Route exact path={`${path}:locale/`} render={goHome} />
            <Route exact path={`${path}:locale/blog`} render={goNews} />
            <Route path={`${path}:locale/blog/category/:category`} render={goNewsCat} />
            <Route path={`${path}:locale/blog/:articleLocale/category/:category`} render={goNewsCat} />
            <Route path={`${path}:locale/blog/:title`} render={goNewsTitle} />
            <Route path={`${path}:locale/home`} component={HomeView} />
            <Route path={`${path}:locale/homev1`} component={HomeViewV1} />
            <Route path={`${path}:locale/download-now`} component={DownloadNowView} />
            <Route path={`${path}:locale/download-now-thankyou`} component={DownloadNowView} />
            <Route path={`${path}:locale/beta-sign-up`} component={SuccessView} />
            <Route exact path={`${path}:locale/news`} component={BlogWrapper} />
            <Route path={`${path}:locale/news/category/:category`} component={BlogWrapper} />
            <Route path={`${path}:locale/news/:title`} component={ArticleWrapper} />
            <Route path={`${path}:locale/faq`} component={FaqView} />
            <Route path={`${path}:locale/eula`} component={EulaView} />
            <Route path={`${path}:locale/page-not-found`} component={Error404} />
            <Route path={`${path}:locale/unexpected-error`} component={Error500} />
            <Route component={Error404} />
        </Switch>
    );
    return routes;
};

export default getRoutes;
